
const backend_address = process.env.VUE_APP_BACKEND_ADDRESS || "http://localhost:8000"

export { backend_address }